<template>
  <div>
    <b-dropdown v-if="showDebugTools" class="debug-tools" variant="link" size="lg" no-caret>
      <template slot="button-content">
        <i v-if="loading" class="fa fa-spinner fa-spin"/>
        <i v-else class="fa fa-cog"/>
      </template>
      <template v-for="(page, pageIndex) in design.pages">
        <b-dropdown-item
          :key="'d'+pageIndex"
          :href="'data:image/svg,'+encodeURIComponent(page.backgroundLayer.svgMarkup)"
          :download="`design${designId}-bg${pageIndex}.svg`"
          >
          <i class="fa fa-file"/>Download Page {{pageIndex}} bg SVG File
        </b-dropdown-item>
        <b-dropdown-item
          :key="'t'+pageIndex"
          :href="'data:image/svg,'+encodeURIComponent(pageSvg[pageIndex])"
          :download="`design${designId}-text${pageIndex}.svg`"
          >
          <i class="fa fa-file"/>Download Page {{pageIndex}} text SVG File ({{pageSvg[pageIndex].length}})
        </b-dropdown-item>
        <b-dropdown-form :key="'u'+pageIndex" style="padding: .25rem 1.5rem;">
          <label style="margin: 0"><i class="fa fa-file"/>Upload Page {{pageIndex}} SVG File
            <input accept="image/svg" type="file" style="display:none;" @change="uploadFile(page, $event)">
          </label>
        </b-dropdown-form>
      </template>
      <b-dropdown-item @click="downloadProductionFile" href="#">
        <i v-if="loading" class="fa fa-spinner fa-spin"/>
        <i v-else class="fa fa-file-o"/>
        Create Production File
      </b-dropdown-item>
      <b-dropdown-item v-if="url" :href="url" target="_blank">
        <i class="fa fa-file"/>Download Production File
      </b-dropdown-item>
      <b-dropdown-item @click="unlockDesign">
        <i class="fa fa-file"/>Unlock design
      </b-dropdown-item>
      <b-dropdown-item target="_blank" :href="templateUrl">
        <i class="fa fa-file"/>View Template
      </b-dropdown-item>
      <b-dropdown-item target="_blank" :href="sourceFileUrl">
        <i class="fa fa-file"/>Source file
      </b-dropdown-item>
      <b-dropdown-item :to="{ name: 'upload-list', query: { search: design.id } }">
        <i class="fas fa-arrow-right"/> View uploaded file details
      </b-dropdown-item>
      <b-dropdown-item v-if="!isTemplate" @click="updateDesign(true)">
        <i class="fa fa-file"/>Clone and Update design...
      </b-dropdown-item>
      <b-dropdown-item v-if="!isTemplate" @click="updateDesign(false)">
        <i class="fa fa-file"/>Update design in-place...
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import {productionFile, updateLayerSvg} from '@/services/design'
import {mapGetters, mapActions} from 'vuex';
export default {
  data() {
    return {
      loading: false,
      url: null
    };
  },
  computed: {
    ...mapGetters(['designId', 'flags', 'design', 'pageSvg', 'designOptions', 'isTemplate']),
    showDebugTools() {
      return this.flags.debugTools
    },
    templateUrl() {
      return '/design/' + this.design.sourceDesign;
    },
    sourceFileUrl() {
      // Note: this may be only one side, if they uploaded in two steps
      return this.design.sourceFile;
    }
  },
  methods: {
    ...mapActions(['setDesignOptions', 'updateDesignTemplate', 'updateDesignTemplateClone']),
    async downloadProductionFile() {
      this.loading = true;
      let result = await productionFile(this.designId);
      this.loading = false;
      console.log(result);
      this.url = result.productionFile
    },
    async uploadFile(page, event) {
      const file = event.target.files[0];
      if (file){
        const reader = new FileReader();
        reader.onload = async (fileEvent) => {
          const data = fileEvent.target.result;

          // Upload to layer...
          await updateLayerSvg(page.backgroundLayer.id, data);
          console.log('done');
        };
        reader.readAsText(file);
      }
    },
    unlockDesign() {
      this.setDesignOptions({...this.designOptions, lockDesign: false});
    },
    async updateDesign(clone) {
      let source_template = +prompt('source_design');
      if (isNaN(source_template)) {
        alert('NaN');
        return;
      }

      if (clone) {
        let newDesignId = await this.updateDesignTemplateClone(source_template);
        // Update url to reflect new design.
        window.open('/design/'+newDesignId, '_blank');
      } else {
        await this.updateDesignTemplate(source_template);
        // TODO reload? page gets wonky
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .debug-tool {
    line-height: 2.4em;
    padding-right: 2em;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/editor/DebugTools.vue